import {ApplicationCredentialsModel} from '../../../models/api/applicationCredentialsModel';
import {ServerAuthenticationConfig} from '../../../models/api/serverModel';

/*
 * Type enum.
 */

export enum ServerEditorActionTypesEnum {
  UPDATE_ORIGIN = '@@server/UPDATE_ORIGIN',
  UPDATE_AUTHENTICATION_CONFIG = '@@server/UPDATE_AUTHENTICATION_CONFIG',
  UPDATE_APPLICATION_CREDENTIALS = '@@server/UPDATE_APPLICATION_CREDENTIALS',
}

/*
 * Types.
 */

interface UpdateServerOrigin {
  type: ServerEditorActionTypesEnum.UPDATE_ORIGIN;
  origin: string;
}

interface UpdateServerAuthenticationConfig {
  type: ServerEditorActionTypesEnum.UPDATE_AUTHENTICATION_CONFIG;
  authenticationConfig: ServerAuthenticationConfig;
}

interface UpdateApplicationCredentials {
  type: ServerEditorActionTypesEnum.UPDATE_APPLICATION_CREDENTIALS;
  applicationCredentials: ApplicationCredentialsModel;
}

/*
 * Combined action type.
 */

export type ServerEditorAction =
  | UpdateServerOrigin
  | UpdateServerAuthenticationConfig
  | UpdateApplicationCredentials;
